var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in_abtCnt"},[_c('div',{staticClass:"in_abtCtop"},[_c('span',{style:(_vm.colors)},[_c('i',{staticClass:"xian1",style:(_vm.xiancolor)}),_vm._v("\n      "+_vm._s(_vm.titletxt)+"\n      "),_c('i',{staticClass:"xian2",style:(_vm.xiancolor)})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2299d236","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index/component/InTitle.vue
// module id = null
// module chunks = 